@if (!isShowcase()) {
    @switch (feature()?.id) {
        @case (featureType.Scoreboard) {
            @if (background().bgImageUrl) {
                <img
                    placeholder
                    class="scoreboard-background-image"
                    fill
                    priority
                    ngSrcset="1x, 2x, 3x"
                    [style.max-height.px]="bgMaxHeight"
                    [ngSrc]="background().bgImageUrl!" />
            }
            <ms-scoreboard [event]="event()" [size]="size()" [hideTimer]="false" [isNewEDPScoreboard]="isNewEDPScoreboard()" />
            @if (event().liveAlert && size() !== sizeDensity.Tiny && !isNewEDPScoreboard()) {
                <ms-alert class="alert-icon" [model]="event()" [style.top.px]="scoreboardHeight" (alertEnabled)="alertEnabled()" />
            }
            @if (showStreamingMessage() && size() !== sizeDensity.Tiny && !isExpanded()) {
                <ms-video-stream-button [event]="event()" (buttonClicked)="onStreamMessageClick()" />
            }
            @if (event().scoreboard.started && showMessageList() && event().scoreboard.messages?.length) {
                <ng-container *ngTemplateOutlet="messageList" />
            }
        }
        @case (featureType.Simulation) {
            @if (eventAnimation) {
                @if (showScoreboard() && !isNewEDPScoreboard() && size() === sizeDensity.Tiny && event().sport.id !== sportConstant.Golf) {
                    <ms-scoreboard [event]="event()" [size]="sizeDensity.Tiny" [hideTimer]="true" />
                }
                @if (size() !== sizeDensity.Tiny || event().sport.id === sportConstant.Golf || isNewEDPScoreboard()) {
                    <ng-container *msComponentProxy="animationComponent" />
                }
                @if (event().liveAlert && size() !== sizeDensity.Tiny) {
                    <ms-alert class="alert-icon" [model]="event()" [style.top.px]="scoreboardHeight" (alertEnabled)="alertEnabled()" />
                }
                @if (showMessageList()) {
                    <ng-container *ngTemplateOutlet="messageList" />
                }
            } @else {
                <ng-container *ngTemplateOutlet="simulation" />
            }
        }
        @case (featureType.Video) {
            @if (showScoreboard() && !isNewEDPScoreboard()) {
                <ms-scoreboard [event]="event()" [size]="sizeDensity.Tiny" [hideTimer]="true" />
            }

            <ng-container *msComponentProxy="videoStreamComponent" />
        }
        @case (featureType.Statistics) {
            <ng-container *ngTemplateOutlet="statsColumn" />
        }
    }
} @else {
    @switch (feature()?.id) {
        @case (featureType.Scoreboard) {
            @if (!isNewEDPScoreboard()) {
                <ms-scoreboard
                    [event]="event()"
                    [size]="event().scoreboard && event().scoreboard.started ? sizeDensity.Medium : sizeDensity.Small"
                    [hideTimer]="false"
                    [isShowcase]="isShowcase()" />
            }
        }
        @case (featureType.Video) {
            <ng-container *msComponentProxy="videoStreamComponent" />
        }
        @case (featureType.Simulation) {
            @if (eventAnimation) {
                <ng-container *msComponentProxy="animationComponent" />
            } @else {
                <ng-container *ngTemplateOutlet="simulation" />
            }
        }
        @case (featureType.Statistics) {
            <ng-container *ngTemplateOutlet="statsColumn" />
        }
    }
}

<ng-template #simulation>
    @if (event().runningBallDataId) {
        <ms-match-simulation
            [runningBall]="event().runningBallDataId!"
            [awayTeam]="event().participants[1].name"
            [homeTeam]="event().participants[0].name" />
    } @else {
        <ng-container *msComponentProxy="animationComponent" />
    }
</ng-template>

<ng-template #statsColumn>
    <div class="stats-column prematch-collapsed">
        <ndc-dynamic
            [ndcDynamicComponent]="eventStatisticsComponent$ | async"
            [ndcDynamicInputs]="{ event: event() }"
            [ndcDynamicOutputs]="eventStatisticsComponentOutputs" />
    </div>
</ng-template>

<ng-template #messageList>
    <div
        class="message-list-container"
        [class.bespoke-message-list-container]="isBespokeScoreboard()"
        [class.short]="eventAnimation && size() === sizeDensity.Large">
        <ms-scoreboard-message-list
            [event]="event()"
            [messages]="event().scoreboard.messages"
            [hasLiveAlert]="isAlertEnabled"
            (toggle)="messageToggled($event)" />
    </div>
</ng-template>
